import moment from 'moment';
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import language from '../../../helpers/language';
import PaginatedComponentView from '../../../components/PaginatedComponent/PaginatedComponentView';
import ResetButtons from '../../../components/ResetButton/ResetButtons';
import DatePicker from 'react-datepicker';

export default function TransactionManagement({
  action_img,
  data,
  filterOrderTransaction,
  handleTransactionOrderPageClick,
  changeOrderTransactionStatus,
}) {
  const history = useHistory();
  const [startDate, setStartDate] = useState('');
  const [lang] = useState(language.getLang());
  const [endDate, setEndtDate] = useState('');
  const [errors, setErrors] = useState({ message: '', isTrue: false });
  const [loader, setLoader] = useState({ isTrue: false, id: '' });

  const filterData = () => {
    const date = {
      start_date: moment(startDate).format('yyyy-MM-DD'),
      end_date: moment(endDate).format('yyyy-MM-DD'),
    };
    setErrors({ message: '', isTrue: false });
    if (date?.start_date !== '' && date?.end_date !== '')
      filterOrderTransaction(date);
    else
      setErrors({
        message: 'Start and end date fields are required.',
        isTrue: false,
      });
  };

  const handleRequestbtn = async (id) => {
    setLoader({ isTrue: true, id: id });
    const res = await changeOrderTransactionStatus(id);

    if (res?.status) {
      setLoader({ isTrue: false, id: '' });
      setErrors({ message: res?.message, isTrue: true });
    } else {
      setLoader({ isTrue: false, id: '' });
      setErrors({ message: res?.message, isTrue: false });
    }
    setTimeout(() => {
      setErrors({ message: '', isTrue: false });
    }, 3000);
  };

  return (
    <>
      <div className="product-title">
        <div className="flex flex-wrap justify-between items-center">
          <h4 className="mb-0">{lang?.Transaction_management}</h4>
          <div className="inner-btn-box">
            {/* <Link
                            to="/marketplace/generate-transaction-report"
                            className="btn btn-blue light-green filterBtn"
                        >
                            <svg width="19" height="22" viewBox="0 0 19 22" fill="none">
                                <path d="M2.3108 0C1.03729 0 0 1.05756 0 2.35594V18.5858C0 19.8842 1.03729 20.9417 2.3108 20.9417H8.72969V19.3711H2.3108C1.88459 19.3711 1.54053 19.0203 1.54053 18.5858V2.35594C1.54053 1.9214 1.88459 1.57063 2.3108 1.57063H8.21618V6.02075C8.21618 7.31913 9.25348 8.37669 10.527 8.37669H14.8918V13.2716C15.126 13.1575 15.3853 13.0886 15.6621 13.0886C15.9389 13.0886 16.1982 13.1575 16.4324 13.2716V7.59138C16.4324 7.37411 16.346 7.17815 16.2067 7.03613L9.53105 0.230073C9.39176 0.0880616 9.19956 0 8.98645 0H2.3108ZM9.75672 2.68111L13.8026 6.80606H10.527C10.1008 6.80606 9.75672 6.45529 9.75672 6.02075V2.68111ZM18.2176 13.0773C18.0135 13.0806 17.819 13.1663 17.6768 13.3157C17.5347 13.465 17.4565 13.6658 17.4594 13.8739V21.2035C17.4579 21.3076 17.4768 21.4109 17.5149 21.5075C17.5529 21.604 17.6094 21.6919 17.6811 21.766C17.7528 21.8401 17.8382 21.899 17.9323 21.9391C18.0265 21.9793 18.1276 22 18.2297 22C18.3317 22 18.4328 21.9793 18.527 21.9391C18.6211 21.899 18.7065 21.8401 18.7782 21.766C18.8499 21.6919 18.9064 21.604 18.9444 21.5075C18.9825 21.4109 19.0014 21.3076 18.9999 21.2035V13.8739C19.0014 13.7688 18.9822 13.6644 18.9434 13.5671C18.9046 13.4697 18.847 13.3812 18.774 13.3069C18.7011 13.2326 18.6142 13.174 18.5187 13.1346C18.4231 13.0952 18.3207 13.0757 18.2176 13.0773ZM15.6501 14.1244C15.446 14.1277 15.2514 14.2134 15.1093 14.3627C14.9671 14.5121 14.8889 14.7129 14.8918 14.921V21.2035C14.8904 21.3076 14.9092 21.4109 14.9473 21.5075C14.9854 21.604 15.0419 21.6919 15.1135 21.766C15.1852 21.8401 15.2706 21.899 15.3648 21.9391C15.459 21.9793 15.56 22 15.6621 22C15.7642 22 15.8652 21.9793 15.9594 21.9391C16.0536 21.899 16.139 21.8401 16.2107 21.766C16.2823 21.6919 16.3388 21.604 16.3769 21.5075C16.415 21.4109 16.4338 21.3076 16.4324 21.2035V14.921C16.4338 14.8159 16.4146 14.7115 16.3758 14.6141C16.337 14.5167 16.2794 14.4283 16.2065 14.354C16.1335 14.2797 16.0467 14.2211 15.9511 14.1817C15.8555 14.1423 15.7532 14.1228 15.6501 14.1244ZM13.0825 15.695C12.8784 15.6983 12.6839 15.784 12.5417 15.9334C12.3996 16.0827 12.3213 16.2835 12.3243 16.4916V21.2035C12.3228 21.3076 12.3417 21.4109 12.3797 21.5075C12.4178 21.604 12.4743 21.6919 12.546 21.766C12.6177 21.8401 12.7031 21.899 12.7972 21.9391C12.8914 21.9793 12.9925 22 13.0945 22C13.1966 22 13.2977 21.9793 13.3919 21.9391C13.486 21.899 13.5714 21.8401 13.6431 21.766C13.7148 21.6919 13.7713 21.604 13.8093 21.5075C13.8474 21.4109 13.8663 21.3076 13.8648 21.2035V16.4916C13.8663 16.3865 13.8471 16.2822 13.8083 16.1848C13.7694 16.0874 13.7119 15.9989 13.6389 15.9246C13.566 15.8504 13.4791 15.7918 13.3835 15.7523C13.288 15.7129 13.1856 15.6934 13.0825 15.695ZM10.5149 17.2657C10.3108 17.2689 10.1163 17.3546 9.97417 17.504C9.832 17.6534 9.75379 17.8541 9.75672 18.0622V21.2035C9.75527 21.3076 9.77413 21.4109 9.81219 21.5075C9.85025 21.604 9.90676 21.6919 9.97843 21.766C10.0501 21.8401 10.1355 21.899 10.2297 21.9391C10.3238 21.9793 10.4249 22 10.527 22C10.6291 22 10.7301 21.9793 10.8243 21.9391C10.9185 21.899 11.0039 21.8401 11.0755 21.766C11.1472 21.6919 11.2037 21.604 11.2418 21.5075C11.2798 21.4109 11.2987 21.3076 11.2973 21.2035V18.0622C11.2987 17.9571 11.2795 17.8528 11.2407 17.7554C11.2019 17.658 11.1443 17.5695 11.0714 17.4953C10.9984 17.421 10.9116 17.3624 10.816 17.3229C10.7204 17.2835 10.618 17.264 10.5149 17.2657Z" fill="white" />
                            </svg>
                            Generate Report
                        </Link> */}
          </div>
        </div>
      </div>

      <div className="productFilter mb--30 justify--between">
        <div className="calenderWrapper">
          <div className="form__item">
            <label>{lang?.Date_from}</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              minDate=""
              // placeholderText="Select date from"
              placeholderText={lang?.selected_date_from}
              dateFormat="dd MMMM yyyy"
            />
          </div>
          <div className="form__item">
            <label>{lang?.Date_to}</label>
            <div className="datePicker">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndtDate(date)}
                minDate=""
                // placeholderText="Select date to"
                placeholderText={lang?.selected_date_to}
                dateFormat="dd MMMM yyyy"
              />
            </div>
          </div>
        </div>
        <div className="btn btn--gray">
          <button type="button" className="btn filterBtn" onClick={filterData}>
            {/* <i className="fa fa-filter" aria-hidden="true"></i> */}
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M5.35132 2L8.35132 5L11.3513 2H5.35132ZM15.3513 2L12.3513 5H18.3513L15.3513 2ZM3.35132 7V9H4.35132V9.0332L9.35132 16.0332V22H15.3513V16.0332L20.3513 9.0332V9H21.3513V7H3.35132ZM6.78491 9H17.9177L13.3513 15.3926V20H11.3513V15.3926L6.78491 9Z"
                fill="black"
              />
            </svg>
            {lang?.Filter}
          </button>
        </div>
      </div>
      {errors?.message && (
        <p style={{ color: errors?.isTrue ? 'green' : 'red' }}>
          {errors?.message}
        </p>
      )}
      {(startDate || endDate) && (
        <ResetButtons
          text={lang?.Reset_filter}
          onclick={() => {
            filterOrderTransaction();
            setStartDate('');
            setEndtDate('');
          }}
        />
      )}
      <div className="product-list transactionMgmt">
        <div className="recentOrder secBlockGap">
          <div className="itemTable itemTableScroll customer__table">
            <table>
              <thead>
                <tr>
                  <th>
                    <div className="CustomId">{lang?.Order_id}</div>
                  </th>
                  <th>
                    <div className="dateField">{lang?.Date}</div>
                  </th>
                  <th>{lang?.Amount}</th>
                  <th className="noWhiteSpace">
                    {lang?.You_earned}{' '}
                    <span>
                      <i
                        className="fa fa-info-circle infoIcon"
                        aria-hidden="true"
                        title={lang?.You_earned_info}
                      ></i>
                    </span>
                  </th>
                  <th>
                    <div className="customer__name_width">{lang?.Customer_Name}</div>
                  </th>
                  {/* <th>{lang?.Payment_status}</th>
                  <th>{lang?.Order_status}</th>
                  <th>{lang?.Action}</th> */}
                </tr>
              </thead>
              <tbody>
                {data?.data?.length > 0 ? (
                  data.data?.map(
                    ({
                      producer_payment_request,
                      order_id,
                      admin_payment_made,
                      charge_id,
                      order_info,
                      created_at,
                      status,
                      paid_amount,
                      buyer_info,
                      id,
                      currency,
                      application_fee,
                    }) => {
                      let isRequest =
                        order_info?.status === lang?.completed &&
                        !producer_payment_request;
                      let isPaid =
                        admin_payment_made && producer_payment_request;
                      return (
                        <tr>
                          <td>{order_id}</td>
                          <td>
                            {moment(created_at).format('DD/MM/YYYY hh:mm A')}
                          </td>
                          <td>
                            {currency}
                            {Number(paid_amount).toFixed(2)}
                          </td>
                          <td>
                            {currency}
                            {Number(paid_amount - application_fee).toFixed(2)}
                          </td>
                          <td className="customer__name_width">
                            {buyer_info?.company_name}
                          </td>
                          {/* <td>
                            <div
                              className={`${
                                isPaid ? 'paid' : 'payStatus notReq'
                              }`}
                            >
                              {isPaid
                                ? lang?.Paid
                                : producer_payment_request
                                ? lang?.Pennding
                                : lang?.Not_requested}
                            </div>
                          </td>
                          <td>
                            <div className="orderStatus transactionStatus">
                              {order_info?.status}
                            </div>
                          </td>
                          <td>
                            <div className="flexBox">
                              <div className="iconGroup">
                                <div
                                  className={`${
                                    isRequest ? 'reqForPay' : 'reqBtn'
                                  }`}
                                  onClick={() =>
                                    order_info?.status === lang?.completed &&
                                    !producer_payment_request &&
                                    !loader?.isTrue &&
                                    handleRequestbtn(order_id)
                                  }
                                >
                                  {loader?.isTrue && loader?.id === order_id
                                    ? `${lang?.Requesting}...`
                                    : producer_payment_request
                                    ? lang?.Requested
                                    : lang?.Request_for_payment}
                                </div>
                                <span
                                  onClick={() =>
                                    history.push(
                                      `/marketplace/producer-transaction-view/${id}`
                                    )
                                  }
                                >
                                  <img
                                    src={action_img}
                                    alt="Action Icon"
                                    title="View"
                                  />
                                </span>
                              </div>
                            </div>
                          </td> */}
                        </tr>
                      );
                    }
                  )
                ) : (
                  <p>{lang?.No_data_found}</p>
                )}
              </tbody>
            </table>
          </div>
          <PaginatedComponentView
            lastPage={data?.last_page}
            handlePageClick={handleTransactionOrderPageClick}
          />
        </div>
      </div>
    </>
  );
}
